// @ts-nocheck
class VendorTopPicks {
  constructor(section) {
    this.section = section;
    this.searchInput = section.querySelector('[data-search-input]');
    this.productsList = section.querySelector('[data-products-list]');
    this.noResults = section.querySelector('[data-no-results]');
    this.addAllBtn = section.querySelector('[data-add-all]');
    this.totalPriceElement = section.querySelector('[data-total-price]');
    this.rows = Array.from(this.productsList.querySelectorAll('.vendor-top-picks__item'));
    
    this.init();
  }

  init() {
    this.setupSearch();
    this.setupColorFilters();
    this.setupQuantityControls();
    this.setupSingleAddButtons();
    this.setupAddAllButton();
  }

  setupSearch() {
    if (!this.searchInput) return;

    let searchTimeout;
    this.searchInput.addEventListener('input', (e) => {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => {
        this.filterProducts(e.target.value);
      }, 300);
    });
  }

  filterProducts(searchTerm) {
    const term = searchTerm.toLowerCase().trim();
    let visibleCount = 0;

    this.rows.forEach(row => {
      const title = row.dataset.productTitle || '';
      const number = row.dataset.productNumber || '';
      
      const matches = title.includes(term) || number.includes(term);
      
      if (matches || term === '') {
        row.style.display = '';
        visibleCount++;
      } else {
        row.style.display = 'none';
      }
    });

    if (visibleCount === 0) {
      this.productsList.style.display = 'none';
      this.noResults.style.display = 'block';
    } else {
      this.productsList.style.display = '';
      this.noResults.style.display = 'none';
    }
  }

  setupColorFilters() {
    const colorSwatches = this.section.querySelectorAll('[data-color-filter]');
    const clearFilterBtn = this.section.querySelector('[data-clear-filter]');

    colorSwatches.forEach(swatch => {
      swatch.addEventListener('click', () => {
        const isActive = swatch.classList.contains('is-active');
        
        if (isActive) {
          swatch.classList.remove('is-active');
          this.clearColorFilter();
        } else {
          const selectedColor = swatch.dataset.colorFilter;
          
          colorSwatches.forEach(s => s.classList.remove('is-active'));
          swatch.classList.add('is-active');
          
          this.filterByColor(selectedColor);
        }
        
        if (this.searchInput) {
          this.searchInput.value = '';
        }
      });
    });

    if (clearFilterBtn) {
      clearFilterBtn.addEventListener('click', () => {
        colorSwatches.forEach(s => s.classList.remove('is-active'));
        this.clearColorFilter();
        
        if (this.searchInput) {
          this.searchInput.value = '';
        }
      });
    }
  }

  filterByColor(colorHash) {
    let visibleCount = 0;

    this.rows.forEach(row => {
      const colorBox = row.querySelector('.vendor-top-picks__color-box');
      if (!colorBox) return;

      const rowColor = colorBox.style.backgroundColor;
      const normalizedRowColor = this.rgbToHex(rowColor) || rowColor;
      const normalizedFilterColor = colorHash.toLowerCase();

      if (normalizedRowColor.toLowerCase() === normalizedFilterColor) {
        row.style.display = '';
        visibleCount++;
      } else {
        row.style.display = 'none';
      }
    });

    if (visibleCount === 0) {
      this.productsList.style.display = 'none';
      this.noResults.style.display = 'block';
    } else {
      this.productsList.style.display = '';
      this.noResults.style.display = 'none';
    }
  }

  clearColorFilter() {
    this.rows.forEach(row => {
      row.style.display = '';
    });

    this.productsList.style.display = '';
    this.noResults.style.display = 'none';
  }

  rgbToHex(rgb) {
    if (!rgb || rgb.startsWith('#')) return rgb;
    
    const result = rgb.match(/\d+/g);
    if (!result || result.length < 3) return rgb;

    const r = parseInt(result[0]);
    const g = parseInt(result[1]);
    const b = parseInt(result[2]);

    return '#' + [r, g, b].map(x => {
      const hex = x.toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    }).join('');
  }

  setupQuantityControls() {
    this.rows.forEach(row => {
      const qtyInput = row.querySelector('[data-qty-input]');
      const decreaseBtn = row.querySelector('[data-qty-decrease]');
      const increaseBtn = row.querySelector('[data-qty-increase]');

      if (!qtyInput || !decreaseBtn || !increaseBtn) return;

      decreaseBtn.addEventListener('click', () => {
        const currentValue = parseInt(qtyInput.value) || 0;
        if (currentValue > 0) {
          qtyInput.value = currentValue - 1;
          this.updateAddAllButtonState();
          this.updateTotalPrice();
          this.updateSelectedState(row);
        }
      });

      increaseBtn.addEventListener('click', () => {
        const currentValue = parseInt(qtyInput.value) || 0;
        const maxValue = parseInt(qtyInput.max) || 999;
        if (currentValue < maxValue) {
          qtyInput.value = currentValue + 1;
          this.updateAddAllButtonState();
          this.updateTotalPrice();
          this.updateSelectedState(row);
        }
      });

      qtyInput.addEventListener('input', () => {
        let value = parseInt(qtyInput.value) || 0;
        const maxValue = parseInt(qtyInput.max) || 999;
        
        if (value < 0) value = 0;
        if (value > maxValue) value = maxValue;
        
        qtyInput.value = value;
        this.updateAddAllButtonState();
        this.updateTotalPrice();
        this.updateSelectedState(row);
      });

      qtyInput.addEventListener('blur', () => {
        if (qtyInput.value === '' || parseInt(qtyInput.value) < 0) {
          qtyInput.value = 0;
          this.updateTotalPrice();
          this.updateSelectedState(row);
        }
      });
    });
  }

  setupSingleAddButtons() {
    this.rows.forEach(row => {
      const addBtn = row.querySelector('[data-add-single]');
      const qtyInput = row.querySelector('[data-qty-input]');
      
      if (!addBtn || !qtyInput) return;

      addBtn.addEventListener('click', async () => {
        const quantity = parseInt(qtyInput.value) || 0;
        
        if (quantity === 0) {
          this.showNotification('Please select a quantity', 'error');
          return;
        }

        const variantId = row.dataset.variantId;
        
        if (!variantId) {
          this.showNotification('Product variant not found', 'error');
          return;
        }

        addBtn.disabled = true;
        addBtn.style.opacity = '0.6';

        try {
          await this.addToCart(variantId, quantity);
          this.showNotification('Added to basket!', 'success');
          qtyInput.value = 0;
        } catch (error) {
          console.error('Error adding to cart:', error);
          this.showNotification('Failed to add to basket', 'error');
        } finally {
          addBtn.disabled = false;
          addBtn.style.opacity = '1';
        }
      });
    });
  }

  setupAddAllButton() {
    if (!this.addAllBtn) return;

    this.addAllBtn.addEventListener('click', async () => {
      const itemsToAdd = [];

      this.rows.forEach(row => {
        const qtyInput = row.querySelector('[data-qty-input]');
        const quantity = parseInt(qtyInput.value) || 0;
        
        if (quantity > 0) {
          const variantId = row.dataset.variantId;
          if (variantId) {
            itemsToAdd.push({
              id: variantId,
              quantity: quantity
            });
          }
        }
      });

      if (itemsToAdd.length === 0) {
        this.showNotification('Please select quantities for products', 'error');
        return;
      }

      this.addAllBtn.disabled = true;
      this.addAllBtn.style.opacity = '0.6';

      try {
        await this.addMultipleToCart(itemsToAdd);
        this.showNotification(`Added ${itemsToAdd.length} product(s) to basket!`, 'success');
        
        this.rows.forEach(row => {
          const qtyInput = row.querySelector('[data-qty-input]');
          if (qtyInput) qtyInput.value = 0;
          row.classList.remove('is-selected');
        });
        
        this.updateAddAllButtonState();
        this.updateTotalPrice();
      } catch (error) {
        console.error('Error adding items to cart:', error);
        this.showNotification('Failed to add items to basket', 'error');
      } finally {
        this.addAllBtn.disabled = false;
        this.addAllBtn.style.opacity = '1';
      }
    });
  }

  updateAddAllButtonState() {
    if (!this.addAllBtn) return;

    const hasQuantity = this.rows.some(row => {
      const qtyInput = row.querySelector('[data-qty-input]');
      return qtyInput && parseInt(qtyInput.value) > 0;
    });

    if (hasQuantity) {
      this.addAllBtn.style.opacity = '1';
      this.addAllBtn.style.pointerEvents = 'auto';
    } else {
      this.addAllBtn.style.opacity = '0.5';
      this.addAllBtn.style.pointerEvents = 'none';
    }
  }

  updateTotalPrice() {
    if (!this.totalPriceElement) return;

    let totalCents = 0;

    this.rows.forEach(row => {
      const qtyInput = row.querySelector('[data-qty-input]');
      const quantity = parseInt(qtyInput?.value) || 0;
      
      if (quantity > 0) {
        const priceInCents = parseInt(row.dataset.price) || 0;
        totalCents += priceInCents * quantity;
      }
    });

    this.totalPriceElement.textContent = this.formatMoney(totalCents);
  }

  updateSelectedState(row) {
    const qtyInput = row.querySelector('[data-qty-input]');
    const quantity = parseInt(qtyInput?.value) || 0;
    
    if (quantity > 0) {
      row.classList.add('is-selected');
    } else {
      row.classList.remove('is-selected');
    }
  }

  formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return `£${dollars}`;
  }

  async addToCart(variantId, quantity) {
    const formData = {
      items: [{
        id: variantId,
        quantity: quantity
      }]
    };

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(formData)
    });

    if (!response.ok) {
      throw new Error('Failed to add to cart');
    }

    const data = await response.json();
    this.updateCartCount();
    return data;
  }

  async addMultipleToCart(items) {
    const formData = {
      items: items
    };

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(formData)
    });

    if (!response.ok) {
      throw new Error('Failed to add items to cart');
    }

    const data = await response.json();
    this.updateCartCount();
    return data;
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const cartCountElements = document.querySelectorAll('[data-cart-count]');
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
      });

      document.dispatchEvent(new CustomEvent('cart:updated', { 
        detail: { cart } 
      }));
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  showNotification(message, type = 'success') {
    const existingNotification = document.querySelector('.vendor-top-picks-notification');
    if (existingNotification) {
      existingNotification.remove();
    }

    const notification = document.createElement('div');
    notification.className = `vendor-top-picks-notification vendor-top-picks-notification--${type}`;
    notification.textContent = message;
    
    const styles = `
      position: fixed;
      bottom: 32px;
      right: 32px;
      padding: 16px 24px;
      background-color: ${type === 'success' ? '#4CAF50' : '#F44336'};
      color: white;
      border-radius: 6px;
      font-family: 'Barlow Condensed', sans-serif;
      font-size: 14px;
      font-weight: 600;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
      z-index: 10000;
      animation: slideInUp 0.3s ease;
    `;
    
    notification.style.cssText = styles;
    document.body.appendChild(notification);

    const styleSheet = document.createElement('style');
    styleSheet.textContent = `
      @keyframes slideInUp {
        from {
          transform: translateY(100px);
          opacity: 0;
        }
        to {
          transform: translateY(0);
          opacity: 1;
        }
      }
    `;
    document.head.appendChild(styleSheet);

    setTimeout(() => {
      notification.style.animation = 'slideInUp 0.3s ease reverse';
      setTimeout(() => {
        notification.remove();
        styleSheet.remove();
      }, 300);
    }, 3000);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[id^="vendor-top-picks-"]');
  sections.forEach(section => {
    new VendorTopPicks(section);
  });
});

if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[id^="vendor-top-picks-"]');
    if (section) {
      new VendorTopPicks(section);
    }
  });
}
